import archivemain       from '@/pages/archive/archive-main/ArchiveMain.vue'
import archive       from '@/pages/archive/archive-page/Archive.vue'
import dictionary       from '@/pages/archive/dictionary/Dictionary.vue'
import archivedetail       from '@/pages/archive/detail'
import archivetree       from '@/pages/archive/archive-tree/ArchiveTree.vue'
import archivetreedetail       from '@/pages/archive/archive-tree-detail/ArchiveTreeDetail.vue'
import expertmain       from '@/pages/archive/expert-column/expert-main/ExpertMain.vue'
import expertdetail       from '@/pages/archive/expert-column/expert-detail/ExpertDetail.vue'


export default [
    {
        path: '/archivemain',
        name: 'archivemain',
        component: archivemain,
    },
    {
        path: '/archive',
        name: 'archive',
        component: archive,
    },
    {
        path: '/dictionary',
        name: 'dictionary',
        component: dictionary,
    },
    {
        path: '/archivedetail',
        name: 'archivedetail',
        component: archivedetail,
    },
    {
        path: '/archivetree',
        name: 'archivetree',
        component: archivetree,
    },
    {
        path: '/archivetreedetail',
        name: 'archivetreedetail',
        component: archivetreedetail,
    },
    {
        path: '/expertmain',
        name: 'expertmain',
        component: expertmain,
    },
    {
        path: '/expertdetail',
        name: 'expertdetail',
        component: expertdetail,
    }
]
